module.exports = fox._r("images/sprite-small-preloader-white.png", __webpack_public_path__ + "_/_/_/common/frame/images/sprite-small-preloader-white.png");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/common/frame/images/sprite-small-preloader-white.png
// module id = 132
// module chunks = 2